module.exports = __webpack_public_path__ + "static/media/i_hr.6dde6918.pdf";